/**
 * Item consume type enum
 */
export enum ItemConsumeType {
  Snapshot = 1, // snapResumeCount
}

/**
 * Snapshot status enum - represents the current state of a snapshot
 */
export enum SnapStatus {
  Invalid = 0,
  Saving = 1,
  Aborted = 2,
  Finished = 3,
  Running = 4,
  Deleting = 5,
  Resumable = 7,
}

/**
 * Snapshot image status enum - represents the state of the underlying image
 */
export enum SnapshotImageStatus {
  Invalid = 0,
  OK = 1,
  GroupPermDenied = 2,
  SourceInvalid = 3,
}

export const SNAPSHOT_ALL_REGIONS_DOMAIN = -1

/**
 * Maps snapshot status codes to i18n translation keys and styles
 * Used for rendering status badges in the UI
 */
export const SNAP_STATUS_MAP = {
  [SnapStatus.Invalid]: { labelKey: 'snapshot.status.invalid', style: 'text-secondary' },
  [SnapStatus.Saving]: { labelKey: 'snapshot.status.saving', style: 'text-warning' },
  [SnapStatus.Aborted]: { labelKey: 'snapshot.status.aborted', style: 'text-secondary' },
  [SnapStatus.Finished]: { labelKey: 'snapshot.status.available', style: 'text-success' },
  [SnapStatus.Running]: { labelKey: 'snapshot.status.running', style: 'text-btn-secondary' },
  [SnapStatus.Deleting]: { labelKey: 'snapshot.status.restorable', style: 'text-primary' },
  [SnapStatus.Resumable]: { labelKey: 'snapshot.status.restorable', style: 'text-primary' },
} as const

/**
 * Maps mismatch reason codes to error messages
 * Used for displaying snapshot compatibility errors
 */
export const MISMATCH_REASON_MAP: Record<number, string> = {
  1: 'CUDA version does not match',
  2: 'Snapshot does not match selected machine',
  3: 'GPU architecture is incompatible with this snapshot',
  4: 'Snapshot does not match selected machine',
  5: 'Snapshot does not match selected machine',
  6: 'The CPU architecture is incompatible with this snapshot',
  8: 'Snapshot need a NPU machine',
  9: 'Snapshot does not match selected machine',
  10: 'Selected machine cannot provide the disk size required for this environment',
  11: 'Snapshot status is not OK',
  12: 'The snapshot partition not match selected machine',
  13: 'Unsupported machine type',
}

/**
 * Maps snapshot image status codes to error messages
 * Used when the underlying image has issues
 */
export const IMAGE_STATUS_ERROR_MAP: Record<SnapshotImageStatus, string | null> = {
  [SnapshotImageStatus.Invalid]: null,
  [SnapshotImageStatus.OK]: null,
  [SnapshotImageStatus.GroupPermDenied]:
    'The underlying image that this snapshot depends on belongs to the course or group. Non-members are not allowed to access it.',
  [SnapshotImageStatus.SourceInvalid]: 'The image this snapshot depends on no longer exists',
}
